import React, { Component } from 'react';
import Notifications5, {notify} from 'react-notify-toast';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import './stripe.connect.css';

@inject('userStore')
class PaymentForm extends Component{
    constructor(props){
        super(props);
        this.state = {
          paymentOption:null,
          busPaymentOption:null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount(){
      this.setState({
        paymentOption:this.props.bus_payment_option
      }, ()=>{
        if (this.state.paymentOption.bus_payment_option){
          this.setState({
            busPaymentOption:this.state.paymentOption.bus_payment_option
          });
        }
      });
    }

    handleInputChange(e) {
        let updatedSelectedItem = Object.assign({}, this.state.busPaymentOption);
        updatedSelectedItem[e.target.name] = e.target.value;
        if (e.target.value === ''){
          updatedSelectedItem = null;
        }
        this.setState({busPaymentOption:updatedSelectedItem});
    }

    render(){
        if (!this.state.paymentOption) return <div className="alert alert-info">Loading</div>;
        const {paymentOption, busPaymentOption} = this.state;
        const {savePaymentOption} = this.props;
        return (
        <React.Fragment>
            <label>{paymentOption.name} {paymentOption.bus_payment_option ? <span className="text-success"><i className="fa fa-check"></i> Configured</span> : null}</label>
            <textarea className="form-control" name="option_text" style={{height:200+"px"}} value={busPaymentOption ? busPaymentOption.option_text:''} onChange={this.handleInputChange}></textarea>
            <div className="btn-group">
            <button className="btn btn-xs btn-primary" onClick={()=>savePaymentOption(busPaymentOption, paymentOption.id, false)}>Save</button>
            {paymentOption.bus_payment_option ? <button className="btn btn-xs btn-danger" onClick={()=>savePaymentOption(busPaymentOption, paymentOption.id, true)}>Delete</button> : null}
            </div>
        </React.Fragment>
        );
    }
}


@inject('userStore')
class SettingsPayments extends Component {
    constructor(props){
        super(props);
        this.state = {
            business:null,
            payment_option_list:[]
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.savePaymentOption = this.savePaymentOption.bind(this);
        this.findById = this.findById.bind(this);
        this.savePaymentOption = this.savePaymentOption.bind(this);
    }

    componentDidMount(){
        this.setState({
          business:this.props.business, payment_option_list:this.props.business.bus_payment_option_list
        });
    }

    savePaymentOption(busPaymentOption, sysPaymentTypeId, shouldDelete){
        post('/v2/save/payment_option', {bus_payment_option:busPaymentOption, sys_payment_type_id:sysPaymentTypeId, should_delete:shouldDelete, hash_id:this.state.business.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
              if (sysPaymentTypeId === 1 && shouldDelete){
                let temp_business = Object.assign({}, this.state.business);
                temp_business.stripe_account_id = null;
                this.setState({business:temp_business});
              }
              let temp_payment_option_list = Object.assign([], this.state.payment_option_list);
              let index = this.state.payment_option_list.findIndex(x => x.id === sysPaymentTypeId);
              temp_payment_option_list[index].bus_payment_option = res.data.bus_payment_option;
              this.setState({
                payment_option_list:temp_payment_option_list
              }, ()=>{notify.show(res.data.message, "success", 3000);});
            } else {
                notify.show(res.data.message, "error", 3000);
            }
        }).catch((error) => {
            notify.show(error, "error", 3000);
            console.log(error);
            return error;
        });
    }



    findById(id){
      let index = this.state.payment_option_list.findIndex(x => x.id === id);
      return this.state.payment_option_list[index];
    }

    handleInputChange(e) {
        let updated_business = Object.assign({}, this.state.business);
        updated_business[e.target.name] = e.target.value;
        this.setState({business:updated_business});
    }

    render(){
        if (!this.state.business) return <div className="alert alert-info">Loading...</div>;
        const {business} = this.state;
        return (
        <React.Fragment>
            <Notifications5 options={{wrapperId:'payments-notifications'}}/>
            <div className="card form-type-combine">
                <h4 className="card-title"><strong>Payment Options</strong></h4>
                <div className="card-body">
                  <p>Enter details for the payment options you accept below.</p>
                  <address>
                    <strong>Example - Check</strong><br/>
                    Please make checks payable to The Beauty Shop and mail to<br/>
                    1234 Street St<br/>
                    Somecity, CA 55555
                  </address>
                  <p>Make sure to save each option.  For Credit Card payments - simply follow the instructions to connect to Stripe and the option will be added.</p>
                  <div className="form-groups-attached">
                      <div className="row">
                          <div className="form-group col-12">
                              <label>Credit Card</label>
                              {business.stripe_account_id ? <React.Fragment><br/><div className="badge badge-info"><span>Stripe Connected</span></div><br/><p>To remove this payment method - first revoke access to SimplyEngaging in Stripe under Business Settings/Authorized Apps.  Then press the delete button</p><button className="btn btn-danger btn-xs" onClick={()=>this.savePaymentOption(this.findById(1).bus_payment_option, this.findById(1).id, true)}>Delete</button></React.Fragment> :
                                <React.Fragment>
                                  <p>Want to simplify your payment processing?  Use online payment processing via Stripe!</p><p>In order to use online payment processing a Stripe account is <strong>required</strong>.  If you need a Stripe account just click the <strong>Join Stripe</strong> button.</p><p>Once you have a Stipe account setup, simply press the <strong>Connect with Stripe</strong> button below and you will be guided through the process of connecting a Stripe Account to process transactions.</p>
                                  <strong>Benefits of using online credit card processing via Stripe:</strong>
                                  <ul className="list-unstyled">
                                    <li><i className="text-success fa fa-check"></i> Accept Credit Cards <small>2.9% + $.30 per transaction</small></li>
                                    <li><i className="text-success fa fa-check"></i> Safe and Secure for your clients</li>
                                    <li><i className="text-success fa fa-check"></i> Seamless payment processing (no manual steps for you)</li>
                                    <li><i className="text-success fa fa-check"></i> Money is availabile in 2 business days</li>
                                    <li><i className="text-success fa fa-check"></i> Easy reporting through Stripe!</li>
                                  </ul>
                                  <h3>Already Have a Stripe Account?</h3>
                                  <a href={business.authorize_url} className="stripe-connect dark"><span>Connect with Stripe</span></a>
                                  <hr/>
                                  <h3>Don't have a Stripe Account?</h3>
                                  <a href="https://https://dashboard.stripe.com/register" target="_blank" className="stripe-connect dark"><span>Join Stripe</span></a>
                                </React.Fragment>
                              }
                          </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-12">
                                <PaymentForm bus_payment_option={this.findById(2)} notifyHandler={notify} savePaymentOption={this.savePaymentOption}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-12">
                                <PaymentForm bus_payment_option={this.findById(3)} notifyHandler={notify} savePaymentOption={this.savePaymentOption}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-12">
                                <PaymentForm bus_payment_option={this.findById(4)} notifyHandler={notify} savePaymentOption={this.savePaymentOption}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
        );
    }
}

export default SettingsPayments;


// <h4 className="card-title"><strong>Payment Information</strong></h4>
// <div className="card-body">
//   <p>Choose the payment options you accept below.</p>
//   <div className="form-groups-attached">
//       <div className="row">
//           <div className="form-group col-12">
//               <label>Credit Card</label>
//               {business.stripe_account_id ? <React.Fragment><br/><div className="badge badge-info"><span>Stripe Connected</span></div></React.Fragment> :
//                 <React.Fragment>
//                   <p>Want to simplify your payment processing?  Use online payment processing via Stripe!  In order to use online payment processing a Stripe account is required.  Simply press the Connect with Stripe button below and you will be guided through the process of connecting a Stripe Account to process transactions.</p>
//                   <strong>Benefits of using online credit card processing via Stripe:</strong>
//                   <ul className="list-unstyled">
//                     <li><i className="text-success fa fa-check"></i> Accept Credit Cards <small>2.9% + $.30 per transaction</small></li>
//                     <li><i className="text-success fa fa-check"></i> Safe and Secure for your clients</li>
//                     <li><i className="text-success fa fa-check"></i> Seamless payment processing (no manual steps for you)</li>
//                     <li><i className="text-success fa fa-check"></i> Money is availabile in 2 business days</li>
//                     <li><i className="text-success fa fa-check"></i> Easy reporting through Stripe!</li>
//                   </ul>
//                   <h3>Already Have a Stripe Account?</h3>
//                   <a href={business.authorize_url} className="stripe-connect dark"><span>Connect with Stripe</span></a>
//                   <hr/>
//                   <h3>Don't have a Stripe Account?</h3>
//                   <a href="#" className="stripe-connect dark"><span>Join Stripe</span></a>
//                 </React.Fragment>
//               }
//           </div>
//         </div>
//         <div className="row">
//             <div className="form-group col-12">
//                 <label>Check Payment</label>
//                 <textarea className="form-control" name="manual_instruction" style={{height:200+"px"}} value={business.description} onChange={this.handleInputChange}></textarea>
//             </div>
//         </div>
//         <div className="row">
//             <div className="form-group col-12">
//                 <label>Cash Payment</label>
//                 <textarea className="form-control" name="manual_instruction" style={{height:200+"px"}} value={business.description} onChange={this.handleInputChange}></textarea>
//             </div>
//         </div>
//     </div>
// </div>



// WEBPACK FOOTER //
// ./src/components/business/SettingsPayments.js